import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_GATEWAY_URL || '';

interface PassAuthUrlResponse {
    code: string;
    message: string;
    timestamp: string;
    requestNo: string;
    authUrl: string;
    expiresIn: number;
}

// requestNo 생성 (mchtId_timestamp_random 형식 - 로그 추적용)
export const generateRequestNo = (): string => {
    const mchtId = process.env.REACT_APP_PASS_AUTH_ID || 'unknown';
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substring(2, 12);
    return `${mchtId}_${timestamp}_${random}`;
};

// PASS 인증 URL 발급 (백엔드 프록시 경유)
export const getPassAuthUrl = async (requestNo: string, closeUrl?: string): Promise<PassAuthUrlResponse> => {
    const response = await axios.post<PassAuthUrlResponse>(
        `${BACKEND_URL}/api/front/nice/auth-url`,
        {
            requestNo,
            closeUrl,
            expMods: ['closeButtonOn'],
        }
    );

    if (String(response.data.code) !== '200') {
        throw new Error(response.data.message || 'PASS 인증 URL 발급 실패');
    }

    return response.data;
};

// 핸드폰 번호 중복 확인 (true = 이미 가입된 번호)
export const validatePhone = async (phone: string): Promise<boolean> => {
    const baseUrl = window.location.origin;
    const response = await axios.get(`${baseUrl}/api/front/auth/validate-phone`, { params: { phone } });
    return response.data.data;
};

// NICE 인증 결과 조회 (콜백 후 txId + requestNo로 결과 획득)
// txId = 콜백에서 전달된 webTransactionId, requestNo = 브라우저 sessionStorage에 저장된 값
export const getPassAuthResult = async (txId: string, requestNo: string): Promise<any> => {
    const baseUrl = window.location.origin;
    const response = await axios.get(
        `${baseUrl}/api/front/nice/result`,
        { params: { txId, requestNo } }
    );
    return response.data;
};

